import React from "react";
import ReactECharts from "echarts-for-react";
import appconstants from "../../../themes/appconstant";

const WhoCharts = ({ text, data, sentTo, submissions }) => {
  const chartOptions = {
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const point = params[0];
        return `People: ${point.data[0]}<br/>Avg. Score: ${point.data[1]}`;
      },
    },
    xAxis: {
      type: "value",
      name: "People",
      nameLocation: "middle",
      nameGap: 30,
      axisLabel: {
        formatter: "{value}",
      },
    },
    yAxis: {
      type: "value",
      name: "Avg. Score",
      nameLocation: "middle",
      nameGap: 50,
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        type: "line",
        data: data?.map((d) => [
          Number(d.userCount).toFixed(2),
          Number(d.avgScore).toFixed(2),
        ]),
        smooth: true,
        showSymbol: true,
        symbolSize: 8,
        itemStyle: {
          color: "#ff4d6d",
        },
        lineStyle: {
          width: 3,
        },
        areaStyle: {
          color: "rgba(255,77,109,0.1)",
        },
      },
    ],
  };

  return (
    <div className=" border-royalPurple bg-white border rounded-[10px]">
      <div className="text-base font-semibold text-dark p-4  border-b">
        {text}
      </div>
      <div className="p-6">
        <div className="flex justify-between">
          <div>{appconstants.who5Score}</div>
          <div className="flex gap-4">
            <div className="py-2 px-3 border border-bgpurple  text-xs font-normal text-gray60 rounded-[10px]">
              {appconstants.sentTo}{" "}
              <span className="text-dark font-semibold">{sentTo}</span>
            </div>
            <div className="py-2 px-3 border border-bgpurple  text-xs font-normal text-gray60 rounded-[10px]">
              {appconstants.submissions}{" "}
              <span className="text-dark font-semibold">{submissions}</span>
            </div>
          </div>
        </div>
        {data.length == 0 ? (
          <div className="flex justify-center my-5 text-lg">No Submissions</div>
        ) : (
          <ReactECharts option={chartOptions} style={{ height: "400px" }} />
        )}
      </div>
    </div>
  );
};

export default WhoCharts;
